import { combineReducers } from 'redux';

import genericErrorReducer from 'modules/global/reducers/generic.error';
import genericLoadingReducer from 'modules/global/reducers/generic.loading';
import genericPageReducer from 'modules/global/reducers/generic.page';
import * as types from 'modules/statistics/actionTypes';

import data from './data';

/**
 * @typedef {{
 *  apiError: string,
 *  isFetching: boolean,
 *  page: import('modules/global/generic.types').Page,
 *  data: import('modules/statistics/reducer/data/selfServiceDashboard/data').SelfServiceStatsDataReducer[]
 * }} StatisticsSelfServiceReducer
 */

export default combineReducers({
  data,
  page: genericPageReducer(types.FETCH_DASHBOARD_SELF_SERVICE_STATS),
  apiError: genericErrorReducer(types.FETCH_DASHBOARD_SELF_SERVICE_STATS),
  isFetching: genericLoadingReducer(types.FETCH_DASHBOARD_SELF_SERVICE_STATS),
});
